interface Props {
  daysToMaturity: number
  urgency: 'red' | 'yellow' | 'green'
  size?: 'sm' | 'md'
}

const STYLES = {
  red: {
    bg: 'bg-red-50',
    text: 'text-red-700',
    border: 'border-red-200',
    dot: 'bg-red-500',
  },
  yellow: {
    bg: 'bg-amber-50',
    text: 'text-amber-700',
    border: 'border-amber-200',
    dot: 'bg-amber-500',
  },
  green: {
    bg: 'bg-emerald-50',
    text: 'text-emerald-700',
    border: 'border-emerald-200',
    dot: 'bg-emerald-500',
  },
} as const

export default function MaturityBadge({ daysToMaturity, urgency, size = 'sm' }: Props) {
  const s = STYLES[urgency]
  const sizeClasses = size === 'md' ? 'px-2.5 py-1 text-xs' : 'px-2 py-0.5 text-[11px]'

  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full font-semibold border ${s.bg} ${s.text} ${s.border} ${sizeClasses}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${s.dot}`} />
      {daysToMaturity}d
    </span>
  )
}
